/**
 * applyDraftTreatment — pick a recipe (a candidate, or a knob change) and produce
 * the draft's derived hexes + full engine tokens. PURE (no network). Emits ONE
 * event: "Candidate Picked".
 *
 * The UI applies the result by looping the 6 hexes through `onThemeChange` and
 * stashing the recipe draft-side; the v2 preview channel sends the recipe itself.
 */
import { buildRecipeTokens, deriveLegacyHexes } from "@/data/theme-engine";
import { track } from "@/lib/analytics";
import type { ApplyDraftTreatmentInput, ApplyDraftTreatmentResult } from "./types";

export function applyDraftTreatment(input: ApplyDraftTreatmentInput): ApplyDraftTreatmentResult {
  const { recipe } = input;
  const tokens = buildRecipeTokens(recipe);
  const hexes = deriveLegacyHexes(tokens);

  track("Candidate Picked", {
    treatmentId: recipe.treatmentId,
    seed: recipe.seed,
    polarity: recipe.polarity,
    fontId: recipe.fontId,
  });

  return { recipe, hexes, tokens };
}
